import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { useContextReportsProduction } from "src/Contexts/ReportProduction/ReportsProductionContextContext";
import { UseAutoCompletedAll } from "src/Contexts/Utils/UseAutoCompletedAll";
import { api } from "src/shared/setup/API/api";

export const UseReportProductionGerente = () => {
  const { userPerfil } = useAuthContext();
  const { handleGetAlert } = useLayoutMainContext();
  const { setLoadingGravar } = useConfigPageContext();
  const { valueAutoCompGerente } = UseAutoCompletedAll();

  const {
    setListReportProductionGerente,
    valuesInputsProductionGerente,
  } = useContextReportsProduction();

  const isProducerUser = userPerfil?.type_user === "PRODUCER";
  const isUniqueReport =
    isProducerUser || valuesInputsProductionGerente.type_report === "UNIQUE";

  const objData = {
    start_date: valuesInputsProductionGerente.start_date,
    end_date: valuesInputsProductionGerente.end_date,
    type_date: valuesInputsProductionGerente.type_date,
    gerente: isUniqueReport ? valueAutoCompGerente.label || undefined : undefined,
    id_gerente: isUniqueReport ? Number(isProducerUser ? userPerfil.id : valueAutoCompGerente.id) || undefined : undefined,
  };

  const handleGetReportProductionGerente = async () => {
    if (!valuesInputsProductionGerente.start_date) {
      return handleGetAlert({ message: "Escolha uma data inicial !" });
    }

    if (!valuesInputsProductionGerente.end_date) {
      return handleGetAlert({ message: "Escolha uma data final !" });
    }

    setLoadingGravar(true);
    setListReportProductionGerente(undefined);

    return api
      .post("/report/productionGerente", objData)
      .then((res) => {
        setListReportProductionGerente(res.data);
      })
      .catch((error) => {
        handleGetAlert({
          message: error?.response?.data?.message || "Erro ao gerar relatório.",
        });
      })
      .finally(() => setLoadingGravar(false));
  };

  const handleSubmit = () => handleGetReportProductionGerente();

  return { handleSubmit };
};
